module.exports = __webpack_public_path__ + "static/ralph-022ad5a9e979514c71093c1e1cb37ed3.png";